<div class="header">
    <span id="logo" class="app-logo">
        <picture>
            <!-- Imagen para tema claro o sin preferencia -->
            <source style="width: 200px" srcset="assets/img/brand/rise-logo-long.svg" media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)">
            <!-- Imagen para tema oscuro -->
            <source style="width: 200px" srcset="assets/img/brand/rise-dark-logo-long.svg" media="(prefers-color-scheme: dark)">
            <!-- Fallback general si no aplica ninguna de las media queries -->
            <img style="width: 200px" class="img" src="assets/img/brand/rise-logo-long.svg" alt="App Logo">
        </picture>
    </span> 

    <div class="logout" (click)="logout()">
        <app-custom-icon
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="'icon-signout'">
        </app-custom-icon>
        <span>Sign Out</span>
    </div>
</div>
<ng-container *ngFor="let item of (mainMenu$ | async)?.items">
    <a
        *featureFlag="item.feature"
        class="item"
        [class.disabled]="item.disabled"
        [routerLink]="item.disabled ? null : item.routerLink"
        [queryParams]="item.disabled ? null : item.params"
        [style.pointer-events]="item.disabled ? 'none' : 'auto'"
        [style.opacity]="item.disabled ? '0.5' : '1'"
        (click)="item.disabled ? $event.preventDefault() : menuItemClickled.emit()">
        <img alt="icon" [src]="item.icon" />
        <span>{{item.label}}</span>
    </a>
</ng-container>
